import React, { useEffect, useState } from "react";
import { Box, Grid, makeStyles, Paper, TextField, Typography } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useHistory, useParams } from "react-router-dom";
import PropTypes from "prop-types";

import { useDispatch, useSelector } from "react-redux";

import {
  fetchSpecialties,
  getSpecialties,
  fetchLanguages,
  getLanguages,
  fetchSupports,
  getSupports,
  updatePersonalInfo,
  updateProfessionalInfo,
  updateVerification,
  updateBankAccount,
  updateAgreement,
  fetchWorkerDetail,
  createWorker,
  activeWorker,
  deactivateWorker,
  terminateWorker,
  reactivateWorker,
  // verifyWorker,
  // fetchWorkerFeedback
} from "store/slices/worker";
import { showToast } from "store/slices/toast";
import AppDialog from "components/Dialog/AppDialog";
import ComponentLoading from "components/Common/ComponentLoading";
import PersonalInformationForm from "views/User/OnBoard/Worker/PersonalInformationForm";
import ProfessionalInformationForm from "views/User/OnBoard/Worker/ProfessionalInformationForm";
import BankAccountForm from "views/User/OnBoard/Worker/BankAccountForm";
import VerificationForm from "views/User/OnBoard/Worker/VerificationForm";
import AgreementForm from "views/User/OnBoard/Worker/AgreementForm";
import ProgressOnboard from "views/User/OnBoard/ProgressOnboard";
import AppConfig, { WORKER_TYPE } from "config/AppConfig";
import AppUtil from "utilities/AppUtil";
import AppConfirmDialog from "components/Dialog/AppConfirmDialog";
import { PART_TYPE_WORKER } from "config/AppConfig";
import AppColor from "utilities/AppColor";
import { getAuthInfo } from "store/slices/auth";
import AppButton from "components/CustomButtons/AppButton";
import { fetchWorkerFeedback } from "store/slices/worker";
import AdminFeedbackForm from "views/User/OnBoard/AdminFeedbackForm";
import { verifyWorker } from "store/slices/worker";
import { deleteFilesVerification } from "store/slices/worker";
import { TrainRounded } from "@material-ui/icons";
import ScrollableTabs from "components/CustomTabs/AppTabsScroll";
import AppSelect from "components/Select/AppSelect";
const { APPROVAL_STATUS, SYSTEM_STATUS } = AppConfig;

const styles = makeStyles(() => ({
  container: {
    padding: "1rem",
  },
  wrapper: {
    padding: '1rem',
    border: '1px solid #d2d2d2'
  },
  wrapperLeft: {
    padding: '1rem',
    marginRight: '1rem',
    border: '1px solid #d2d2d2'
  },
  wrapperBottom: {
    padding: '1rem',
    marginBottom: '1rem',
    border: '1px solid #d2d2d2'
  },
  wrapperRight: {
    padding: '1rem',
    border: '1px solid #d2d2d2'
  },
  boxActive: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '2rem 0.5rem'
  },
  title: {
    display: 'flex',
    marginBottom: '1rem',
    '& h5': {
      color: AppColor.mainColor
    }
  },
}));

const WorkerDetail = () => {
  const { t } = useTranslation();
  const isMobile = AppUtil.mobileAndTabletCheck();
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = styles();
  const { type, id } = useParams();

  const [loading, setLoading] = useState(false);
  const [showConfirmActive, setShowConfirmActive] = useState(false);
  const [showConfirmDeactivate, setShowConfirmDeactivate] = useState(false);
  const [showConfirmReactivate, setShowConfirmReactivate] = useState(false);
  const [showConfirmTerminate, setShowConfirmTerminate] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isWaitingApproval, setIsWaitingApproval] = useState(false);
  const [isValidAll, setIsValidAll] = useState(false);
  const [isCreate, setIsCreate] = useState(false);
  const [isUpdate, setIsUpdate] = useState(false);
  const [currentStep, setCurrentStep] = useState(0);
  const [workerDetail, setWorkerDetail] = useState({});
  const [workerFeedback, setWorkerFeedback] = useState([]);
  const [partTypeWorker, setPartTypeWorker] = useState();
  const [reason, setReason] = useState('');
  const [terminationReason, setTerminationReason] = useState('');


  const [workerOnboard, setWorkerOnboard] = useState([
    { label: 'title.personalInformation', checked: false, code: PART_TYPE_WORKER.PERSONAL_INFO, active: true },
    { label: 'title.professionalInformation', checked: false, code: PART_TYPE_WORKER.PROFESSIONAL_INFO, active: true },
    { label: 'title.verification', checked: false, code: PART_TYPE_WORKER.VERIFICATION, active: true },
    { label: 'title.bankAccount', checked: false, code: PART_TYPE_WORKER.BANK_ACCOUNT, active: true },
    { label: 'title.agreement', checked: false, code: PART_TYPE_WORKER.AGREEMENT, active: false }
  ]);

  const specialties = useSelector(getSpecialties) || [];
  const languages = useSelector(getLanguages) || [];
  const supports = useSelector(getSupports) || [];
  const [workerType, setWorkerType] = useState(type);

  const userInfo = useSelector(getAuthInfo);

  const {
    id: workerId,
    approvalStatus
  } = workerDetail;

  const { companyId } = userInfo;

  useEffect(() => {
    dispatch(fetchLanguages());
    if (window.location.href.includes('create')) {
      setIsCreate(true);
    } else {
      setIsCreate(false);
    }
  }, []);

  useEffect(() => {
    if (workerType === WORKER_TYPE.SUPPORT_WORKER) {
      dispatch(fetchSupports());
    } else {
      dispatch(fetchSpecialties());
    }
  }, [workerType]);

  useEffect(() => {
    if (id) {
      setIsUpdate(true)
      loadWorkerDetail();
      !isCreate && loadWorkerFeedback();
    }
  }, [id]);

  useEffect(() => {
    switch (currentStep) {
      case 0:
        setPartTypeWorker(PART_TYPE_WORKER.PERSONAL_INFO);
        break;
      case 1:
        setPartTypeWorker(PART_TYPE_WORKER.PROFESSIONAL_INFO);
        break;
      case 2:
        setPartTypeWorker(PART_TYPE_WORKER.VERIFICATION);
        break;
      case 3:
        setPartTypeWorker(PART_TYPE_WORKER.BANK_ACCOUNT);
        break;
      case 4:
        setPartTypeWorker(PART_TYPE_WORKER.AGREEMENT);
        break;
      default:
        setPartTypeWorker(PART_TYPE_WORKER.PERSONAL_INFO);
        break;
    }
  }, [currentStep]);

  const loadWorkerFeedback = async () => {
    if (id) {
      const result = await dispatch(fetchWorkerFeedback({ workerId: id }));
      if (result.payload) {
        setWorkerFeedback([...result.payload]);
      }
    }
  };

  const loadWorkerDetail = async () => {
    const result = await dispatch(fetchWorkerDetail({ workerId: id }));
    if (result.payload) {
      const workerInfo = { ...result.payload };
      setWorkerType(workerInfo.workerType);
      setWorkerDetail({ ...result.payload });
      if (workerInfo.approvalStatus === APPROVAL_STATUS.WAITING_FOR_APPROVAL || workerInfo.approvalStatus === APPROVAL_STATUS.REJECT) {
        setIsWaitingApproval(true);
      } else {
        setIsWaitingApproval(false);
      }
    } else {
      history.push('/admin/workers');
    }
  };

  const submitPersonalInfo = async (form) => {
    let params;
    setLoading(true);
    let result;
    if (workerId) {
      params = {
        ...form
      }
      delete params.contentData.email;
      result = await dispatch(updatePersonalInfo(params));
    } else {
      params = {
        ...form
      }
      params.contentData["domain"] = window.location.host;
      params.contentData["companyId"] = companyId;
      params.contentData["workerType"] = workerType;
      params.contentData["email"] = form.contentData.email.trim();
      result = await dispatch(createWorker(params));
    }
    setLoading(false);
    if (result.payload) {
      AppUtil.scrollToTopById("main-panel");
      if (isCreate) {
        history.push(`/admin/workers`);
      } else {
        loadWorkerDetail();
      }
      handleCheckProgress(0);
    }
  };
  const submitProfessionalInfo = async (form) => {
    setLoading(true);
    const result = await dispatch(updateProfessionalInfo(form));
    setLoading(false);
    if (result.payload) {
      loadWorkerDetail();
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(1);
    }
  };
  const submitVerification = async (form) => {
    setLoading(true);
    const result = await dispatch(updateVerification(form));
    setLoading(false);
    if (result.payload) {
      loadWorkerDetail();
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(2);
    }
  };
  const submitBankAccount = async (form) => {
    setLoading(true);
    const result = await dispatch(updateBankAccount(form));
    setLoading(false);
    if (result.payload) {
      loadWorkerDetail();
      AppUtil.scrollToTopById("main-panel");
      handleCheckProgress(3);
    }
  };
  const submitAgreement = async (form) => {
    setLoading(true);
    const result = await dispatch(updateAgreement(form));
    setLoading(false);
    if (result.payload) {
      loadWorkerDetail();
      AppUtil.scrollToTopById("main-panel");
    }
  };

  const handleCheckProgress = (index) => {
    if (index + 1 < workerOnboard.length) {
      setCurrentStep(index + 1);
    }
  };

  const handleBackStep = (index) => {
    if ((approvalStatus === APPROVAL_STATUS.PENDING || isCreate) && index > currentStep) {
      if (workerOnboard[currentStep].checked) {
        for (let i = currentStep; i <= index; i++) {
          if (!workerOnboard[i].checked) {
            setCurrentStep(i);
            return;
          }
        }
        setCurrentStep(index);
      } else {
        dispatch(showToast({
          type: "warning",
          message: t(`toast.warning.needCompleteForm`),
        }));
      }
      return;
    }
    setCurrentStep(index);
  };

  const handleProgressStatus = (index, isCheck) => {
    const clone = [...workerOnboard];
    clone[index].checked = isCheck;
    setWorkerOnboard(clone);
    if (isCreate && isCheck && clone.filter(item => item.checked === false)[0]) {
      handleCheckProgress(index);
    }

    let percent = clone.filter(item => item.checked);
    const numberFormComplete = percent.length;
    const numberForm = clone.length;
    if (numberFormComplete === numberForm) {
      setIsValidAll(true);
      if (isCreate) {
        setTimeout(() => {
          history.push(`/admin/workers`);
        }, 1000);
      }
    }
  };
  const handleActiveWorker = async () => {
    setIsSubmitting(true);
    await dispatch(activeWorker({ workerId }));
    setShowConfirmActive(false);
    loadWorkerDetail();
    setIsSubmitting(false);
  };
  const handleDeactivateWorker = async () => {
    setIsSubmitting(true);
    await dispatch(deactivateWorker({ workerId, data: { reason: reason, status: SYSTEM_STATUS.DEACTIVATE } }));
    setShowConfirmDeactivate(false);
    loadWorkerDetail();
    setReason('');
    setIsSubmitting(false);
  };
  const handleTerminateWorker = async () => {
    setIsSubmitting(true);
    await dispatch(terminateWorker({ workerId, data: { terminationReason: terminationReason, reason: terminationReason === 'OTHER' ? reason : '', status: SYSTEM_STATUS.TERMINATE } }));
    setShowConfirmTerminate(false);
    loadWorkerDetail();
    setTerminationReason('');
    setReason('');
    setIsSubmitting(false);
  };
  const handleReactivateWorker = async () => {
    setIsSubmitting(true);
    await dispatch(reactivateWorker({ workerId, data: { reason: '', status: SYSTEM_STATUS.ACTIVE } }));
    setShowConfirmReactivate(false);
    loadWorkerDetail();
    setIsSubmitting(false);
  };
  const handleRejectForm = async (form) => {
    const { feedbackId, ...rest } = form;
    const params = {
      ...rest,
      workerId,
      partTypeWorker: partTypeWorker,
      isRejected: feedbackId ? false : true
    };
    const result = await dispatch(verifyWorker(params));
    if (result.payload) {
      loadWorkerFeedback();
    }
  };

  const handleDeleteFilesVerification = async (data) => {
    setIsSubmitting(true);
    await dispatch(deleteFilesVerification(data));
    setIsSubmitting(false);
    loadWorkerDetail();
  };
  const showToastDanger = (message) => {
    dispatch(
      showToast({
        type: "danger",
        message: message,
      })
    );
  }
  const handleReason = (status) => {
    return (
      <Box>
        <Typography variant="body2" gutterBottom style={{ marginBottom: '1rem' }}>
          {status === SYSTEM_STATUS.DEACTIVATE ? t('text.deactivateWorker') : t('text.terminateWorker')}
        </Typography>
        {status === SYSTEM_STATUS.DEACTIVATE ? (
          <TextField
            fullWidth
            variant="outlined"
            size="small"
            multiline
            rows={4}
            label={t('label.reason')}
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        ) : (
          <>
            <AppSelect
              label={t('label.reason')}
              defaultValue={""}
              placeholder={t('Select Reason')}
              options={[
                { value: 'VOLUNTARY_CESSATION', label: t('label.voluntary_cessation', 'Voluntary Cessation') },
                { value: 'ILL_HEALTH', label: t('label.ill_health', 'Ill Health') },
                { value: 'DECEASED', label: t('label.deceased', 'Deceased') },
                { value: 'REDUNDANCY', label: t('label.redundancy', 'Redundancy') },
                { value: 'DISMISSAL', label: t('label.dismissal', 'Dismissal') },
                { value: 'CONTRACT_CESSATION', label: t('label.contract_cessation', 'Contract Cessation') },
                { value: 'TRANSFER', label: t('label.transfer', 'Transfer') },
                { value: 'OTHER', label: t('label.other', 'Other') }
              ]}
              onChange={(selectedOption) => {
                setTerminationReason(selectedOption.value);
                if (selectedOption.value !== 'OTHER') {
                  setReason('');
                }
              }}
              value={[
                { value: 'VOLUNTARY_CESSATION', label: t('label.voluntary_cessation', 'Voluntary Cessation') },
                { value: 'ILL_HEALTH', label: t('label.ill_health', 'Ill Health') },
                { value: 'DECEASED', label: t('label.deceased', 'Deceased') },
                { value: 'REDUNDANCY', label: t('label.redundancy', 'Redundancy') },
                { value: 'DISMISSAL', label: t('label.dismissal', 'Dismissal') },
                { value: 'CONTRACT_CESSATION', label: t('label.contract_cessation', 'Contract Cessation') },
                { value: 'TRANSFER', label: t('label.transfer', 'Transfer') },
                { value: 'OTHER', label: t('label.other', 'Other') }
              ].find(opt => opt.value === terminationReason)}
            />
            {terminationReason === 'OTHER' && (
              <Box mt={2}>
                <TextField
                  fullWidth
                  variant="outlined"
                  size="small"
                  multiline
                  rows={4}
                  label={t('label.reason', 'Reason')}
                  value={reason}
                  onChange={(e) => setReason(e.target.value)}
                />
              </Box>
            )}
          </>
        )}
      </Box>
    )
  }

  const tabsForMobile = [
    {
      id: 0,
      title: t(workerOnboard[0].label),
      checked: workerOnboard[0].checked,
      component: <PersonalInformationForm
        onSubmit={submitPersonalInfo}
        workerDetail={workerDetail}
        changeProgressStatus={handleProgressStatus}
        display={TrainRounded}
        type={workerType}
        isUpdate={isUpdate}
      />
    },
    {
      id: 1,
      title: t(workerOnboard[1].label),
      checked: workerOnboard[0].checked,
      component: <ProfessionalInformationForm
        specialties={specialties}
        languages={languages}
        supports={supports}
        onSubmit={submitProfessionalInfo}
        workerDetail={workerDetail}
        changeProgressStatus={handleProgressStatus}
        display={workerOnboard[0].checked}
        type={workerType}
      />
    },
    {
      id: 2,
      title: t(workerOnboard[2].label),
      checked: workerOnboard[1].checked,
      component: <VerificationForm
        onSubmit={submitVerification}
        workerDetail={workerDetail}
        changeProgressStatus={handleProgressStatus}
        display={workerOnboard[1].checked}
        type={workerType}
        onDeleteFilesVerification={handleDeleteFilesVerification}
        showToastDanger={showToastDanger}
      />
    },
    {
      id: 3,
      title: t(workerOnboard[3].label),
      checked: workerOnboard[2].checked,
      component: <BankAccountForm
        onSubmit={submitBankAccount}
        workerDetail={workerDetail}
        changeProgressStatus={handleProgressStatus}
        display={workerOnboard[2].checked}
        type={workerType}
      />
    },
    {
      id: 4,
      title: t(workerOnboard[4].label),
      checked: workerOnboard[3].checked,
      component: <AgreementForm
        onSubmit={submitAgreement}
        workerDetail={workerDetail}
        changeProgressStatus={handleProgressStatus}
        display={workerOnboard[3].checked}
        type={workerType}
      />
    }
  ];
  console.log("worker", workerDetail);
  return (
    <Box>
      <Box className={classes.title}>
        <Typography variant="h5">
          {`${isCreate ? t("label.create") : t("label.edit")} - ${workerType ? workerType === WORKER_TYPE.SUPPORT_WORKER ? t("label.supportWorker") : t("label.nurse") : ''}`}
        </Typography>
      </Box>
      {
        isCreate
          ?
          <PersonalInformationForm
            onSubmit={submitPersonalInfo}
            workerDetail={workerDetail}
            changeProgressStatus={handleProgressStatus}
            display={currentStep === 0}
            type={workerType}
            isUpdate={isUpdate}
            isCreate={isCreate}
          />
          : (isMobile
            ? <ScrollableTabs
              swipeable={false}
              style={{ fontSize: isMobile ? 13 : '' }}
              activeTab={currentStep}
              onChangeTab={setCurrentStep}
              // notFullWidth={true}
              tabs={tabsForMobile.map(item => {
                return {
                  tabLabel: item.title,
                  disabled: !item.checked,
                  tabContent: item.component
                }
              })}
            />
            : <Grid container justifyContent="center">
              <Grid item xs={12} sm={6} md={4}>
                <Paper className={isMobile ? classes.wrapperBottom : classes.wrapperLeft}>
                  <ProgressOnboard
                    step={currentStep}
                    progress={workerOnboard}
                    handleBackStep={handleBackStep}
                    hideCircle={true}
                    feedbacks={isWaitingApproval && workerFeedback.map(item => {
                      item["partType"] = item.partTypeWorker;
                      return item;
                    })}
                  />
                </Paper>
                {
                  isWaitingApproval && isValidAll && workerFeedback.length === 0 && (
                    <Box className={classes.boxActive}>
                      <AppButton
                        label={`${t("button.active")}`}
                        onClick={() => setShowConfirmActive(true)}
                        rounder
                        buttonColor={AppColor.mainColor}
                        isLoading={isSubmitting}
                        disabled={isSubmitting}
                      />
                    </Box>
                  )
                }

                {
                  workerDetail && workerDetail.APPROVAL_STATUS === APPROVAL_STATUS.ACTIVE && (
                    <Box className={classes.boxActive}>
                    </Box>
                  )

                }

                {
                  workerDetail && workerDetail.approvalStatus === APPROVAL_STATUS.ACTIVE && (
                    <Box className={classes.boxActive}>
                      {
                        workerDetail.status === SYSTEM_STATUS.DEACTIVATE &&
                        <AppButton
                          label={`${t("button.reactivate")}`}
                          onClick={() => setShowConfirmReactivate(true)}
                          rounder
                          buttonColor={AppColor.mainColor}
                          isLoading={isSubmitting}
                          disabled={isSubmitting}
                          style={{ marginRight: '1rem' }}
                        />
                      }
                      {
                        workerDetail.status === SYSTEM_STATUS.ACTIVE &&
                        <AppButton
                          label={`${t("button.deactivate")}`}
                          onClick={() => setShowConfirmDeactivate(true)}
                          rounder
                          buttonColor={AppColor.orange}
                          isLoading={isSubmitting}
                          disabled={isSubmitting}
                          style={{ marginRight: '1rem' }}
                        />
                      }
                      {
                        workerDetail.status !== SYSTEM_STATUS.TERMINATE &&
                        <AppButton
                          label={`${t("button.terminate")}`}
                          onClick={() => setShowConfirmTerminate(true)}
                          rounder
                          buttonColor={AppColor.red}
                          isLoading={isSubmitting}
                          disabled={isSubmitting}
                        />
                      }
                    </Box>
                  )
                }

              </Grid>
              <Grid item xs={12} sm={6} md={8}>
                <Paper className={classes.wrapperRight}>
                  <PersonalInformationForm
                    onSubmit={submitPersonalInfo}
                    workerDetail={workerDetail}
                    changeProgressStatus={handleProgressStatus}
                    display={currentStep === 0}
                    type={workerType}
                    isUpdate={isUpdate}
                  />
                  <ProfessionalInformationForm
                    specialties={specialties}
                    languages={languages}
                    supports={supports}
                    onSubmit={submitProfessionalInfo}
                    workerDetail={workerDetail}
                    changeProgressStatus={handleProgressStatus}
                    display={currentStep === 1}
                    type={workerType}
                  />
                  <VerificationForm
                    onSubmit={submitVerification}
                    onDeleteFilesVerification={handleDeleteFilesVerification}
                    workerDetail={workerDetail}
                    changeProgressStatus={handleProgressStatus}
                    display={currentStep === 2}
                    showToastDanger={showToastDanger}
                    type={workerType}
                  />
                  <BankAccountForm
                    onSubmit={submitBankAccount}
                    workerDetail={workerDetail}
                    changeProgressStatus={handleProgressStatus}
                    display={currentStep === 3}
                    type={workerType}
                  />
                  <AgreementForm
                    onSubmit={submitAgreement}
                    workerDetail={workerDetail}
                    changeProgressStatus={handleProgressStatus}
                    display={currentStep === 4}
                    type={workerType}
                  />
                  {
                    isWaitingApproval && (
                      <React.Fragment>
                        <hr />
                        <AdminFeedbackForm
                          onSubmit={handleRejectForm}
                          isWorker={true}
                          display={isWaitingApproval}
                          feedback={workerFeedback.filter(item => item.partTypeWorker === partTypeWorker)[0]}
                        />
                      </React.Fragment>
                    )
                  }
                </Paper>
              </Grid>
            </Grid>
          )

      }
      <AppDialog
        open={loading}
        onClose={() => setLoading(false)}
        noTitle
        noCloseButton
        disableEscapeKeyDown
      >
        <Box my={3}>
          <ComponentLoading />
        </Box>
      </AppDialog>
      <AppConfirmDialog
        open={showConfirmActive}
        onConfirm={() => handleActiveWorker()}
        onClose={() => setShowConfirmActive(false)}
        title={t('title.activeWorker')}
        content={t('text.activeWorker')}
      />
      <AppDialog
        open={showConfirmDeactivate}
        onClose={() => setShowConfirmDeactivate(false)}
        actions={[
          {
            label: t('button.cancel'),
            mode:"outlined",
            onPress: () => setShowConfirmDeactivate(false),
            rounder: true,
            disabled: isSubmitting,
          },
          {
            label: t('button.yes'),
            onPress: () => {
              handleDeactivateWorker();
            },
            rounder: true,
            buttonColor: AppColor.pink,
            isLoading: isSubmitting,
            disabled: isSubmitting,
          }
        ]}
        title={t('title.deactivateWorker')}
      >
        {handleReason(SYSTEM_STATUS.DEACTIVATE)}

      </AppDialog>
      <AppConfirmDialog
        open={showConfirmReactivate}
        onConfirm={() => handleReactivateWorker()}
        onClose={() => setShowConfirmReactivate(false)}
        title={t('title.reactivateWorker')}
        content={t('text.activateWorker')}
      />
      <AppDialog
        open={showConfirmTerminate}
        onClose={() => {
          setShowConfirmTerminate(false);
          setTerminationReason('');
          setReason('');
        }}
        title={t('title.terminateWorker')}
        maxWidth={"sm"}
        actions={[
          {
            label: t('button.cancel'),
            mode:"outlined",
            onPress: () => {
              setShowConfirmTerminate(false);
              setTerminationReason('');
              setReason('');
            },
            rounder: true,
            disabled: isSubmitting,
          },
          {
            label: t('button.yes'),
            onPress: () => {
              handleTerminateWorker();
            },
            rounder: true,
            buttonColor: AppColor.pink,
            isLoading: isSubmitting,
            disabled: isSubmitting || !terminationReason?.trim() || (terminationReason === 'OTHER' && !reason.trim()),
          }
        ]}
      >
        {handleReason(SYSTEM_STATUS.TERMINATE)}
        {!terminationReason?.trim() ? (
          <span style={{ color: 'red', fontSize: 13, marginTop: 8, marginLeft: 4, display: 'block' }}>
           * {t('') || "Reason is required."}
          </span>
        ) : (terminationReason === 'OTHER' && !reason.trim()) ? (
          <span style={{ color: 'red', fontSize: 13, marginTop: 8, marginLeft: 4, display: 'block' }}>
           * {t('') || "Please specify the other reason."}
          </span>
        ) : null}

      </AppDialog>
    </Box >
  );
}

WorkerDetail.propTypes = {
  authInfo: PropTypes.object
};

export default WorkerDetail;
